var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"iconbutton",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"iconimage",attrs:{"src":require("@/assets/pencilplus.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }